
import { Types } from 'app/actions/company-admin/page-groups';
import utils from 'app/reducers/utils';

const initialState = {
  groupIds: null,
  summary: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.SEARCH}_PENDING`]: (state, _action) => {
    return {...state,
      summary: null,
      groupIds: null,
      loadPending: true,
    };
  },
  [`${Types.SEARCH}_RESOLVED`]: (state, {result: {summary, groups}}) => {
    return {...state,
      summary,
      groupIds: groups.map(groups => groups.id),
      loadPending: false,
    };
  },
  [`${Types.SEARCH}_REJECTED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
